export default __webpack_public_path__ + "static/09_Monkey-ad97c4ee85e1598ae5cbde3d0b86192b.png";